<template>
    <div class="splash-container__block splash-container__block_logo">
        <div class="splash-logo">
            <publisher-icon class="splash-logo__img" :icon-name="'IconAuthorization'" />
        </div>
    </div>
</template>
